export const INACTIVITY_TIME = 5000; // 5 seconds

export const EVENT_TYPE = {
  INTERVENTION: "intervention-update",
};
